<template>
    <div class="row">
        <div class="col-12 col-md-9 col-lg-7">
            <div class="card">
                <div class="card-header bg-info my-0 mx-0" style="border-bottom-left-radius: 0 !important; border-bottom-right-radius: 0 !important;">
                    <h4 class="my-0">Listado de Sistemas de Clientes que tienen tareas programadas</h4>
                </div>
                <div class="card-body my-0 mx-0" style="border-top-left-radius: 0 !important; border-top-right-radius: 0 !important;">
                    <div class="table-responsive" v-loading="loading">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Hostname</th>
                                    <th width="10">Detalle</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="!clients.length">
                                    <tr>
                                        <td colspan="3" class="text-center">
                                            No hay registros
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr v-for="(item, index) in clients">
                                        <td>{{ customIndex(index) }}</td>
                                        <td>{{ item.hostname }}</td>
                                        <td width="10">
                                            <el-button
                                                type="primary"
                                                size="mini"
                                                @click.prevent="openDetails(item)"
                                            >
                                                <i class="fa fa-search"></i>
                                            </el-button>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>

                    <el-pagination
                        :total="pagination.total"
                        :current-page.sync="pagination.current_page"
                        :page-size="pagination.per_page"
                        @current-change="loadData"
                        layout="total, prev, pager, next"
                    ></el-pagination>
                </div>
            </div>
        </div>

        <ModalDetails
            :showDialog.sync="showDialog"
            :dataItem="dataItem"
        />
    </div>
</template>

<script>
    import ModalDetails from './components/ModalDetails.vue'

    export default {
        name: 'system-scheduled-task-index',
        components: {
            ModalDetails
        },
        data() {
            return {
                resource: 'scheduled-tasks',
                clients: [],
                pagination: {},
                loading: false,
                showDialog: false,
                dataItem: null
            }
        },
        async created() {
            await this.loadData()
        },

        methods: {
            customIndex(index) {
                return (
                    this.pagination.per_page * (this.pagination.current_page - 1) +
                    index +
                    1
                )
            },

            async loadData() {
                try {
                    this.loading = true
                    const { data } = await this.$http.get(`/${this.resource}/records`, {
                        params: {
                            page: this.pagination.current_page
                        }
                    })
                    this.clients = data.data
                    this.pagination = data.meta
                } catch (error) {
                    
                } finally {
                    this.loading = false
                }
            },

            openDetails(item) {
                this.showDialog = true
                this.dataItem = item
            }
        },
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/system/scheduled_task/index.vue